import * as Yup from "yup";

export const REGISTER_TYPE = {
  DOMESTIC: "DOMESTIC",
  OTHER: "OTHER",
};

export const COMPANY_TYPE_21 = "65977d420bc44668bd1ac6e7"

export const initialValues = {
  registerType: REGISTER_TYPE.DOMESTIC,
  companyName: "",
  companyNameEn: "",
  taxId: "",
  // branchId: "",
  companyTypeId: null,
  numberOfEmployees: "",
  companyTypeDesc: "",

  address: "",
  addressEn: "",
  provinceId: null,
  districtId: null,
  subdistrictId: null,
  zipCode: null,

  telNo: "",
  phoneNo: "",
  email: "",
  faxNo: ""
};

const CompanyProfileInfoSchema = Yup.object().shape({
  companyName: Yup.string().required("Please enter your company name (TH)."),
  // companyNameEn: Yup.string().required("Please enter your company name (EN)."),
  // taxId: Yup.string().required("Please enter tax id."),
  // branchId: Yup.string().required("Please select your branch company."),
  companyTypeId: Yup.string().required("Please select your business type."),
  numberOfEmployees: Yup.number().moreThan(0, "Number of employees must be greater than 0").required(
    "Please input number of employees in your company."
  ),
  companyTypeDesc: Yup.string().when("companyTypeId", {
    is: (val) => val === COMPANY_TYPE_21,
    then: () => Yup.string().required("Please enter company type description."),
    otherwise: () => Yup.string().notRequired(),
  }),

  taxId: Yup.string().when("registerType", {
    is: (val) => val === REGISTER_TYPE.OTHER,
    then: () => Yup.string().required("Please enter taxId."),
    otherwise: () => Yup.string().notRequired(),
  }),

  address: Yup.string()
    .required("Please enter your company address detail (TH)"),
  // .matches(/[\u0E00-\u0E7F]+/, "Must not contain english characters"),
  addressEn: Yup.string()
    .required("Please enter your company address detail (EN)"),
  // .matches(/[a-zA-Z]+/, "Must not contain thai characters"),
  provinceId: Yup.string().required("Please select."),
  districtId: Yup.string().required("Please select."),
  subdistrictId: Yup.string().required("Please select."),
  zipCode: Yup.number()
    .min(10000, "Invalid postal code.")
    .max(99999, "Invalid postal code.")
    .required("Please select."),

  phoneNo: Yup.string().required("Please enter."),
  email: Yup.string()
    .email("Invalid email")
    .required("Please enter your email"),
});

export default CompanyProfileInfoSchema;
